'use client';

import '@byted/tt4b-toolbar/dist/lib/index.css';

/**
 * Known issues in @byted/tt4b-toolbarv0.2.3
 * - https://business.tiktok.com/api/bff/v3/bm/setting/csrf-token fails, causing TypeError: Cannot read properties of null (reading 'csrfToken')
 * - platform enum doesn't include App Center
 */
export function TT4BToolbar({ className }: { className?: string }) {
  return (
    <div
      className={className}
      ref={(node) => {
        if (!node) return;
        import('@byted/tt4b-toolbar').then(({ renderTT4BToolbar }) => {
          renderTT4BToolbar({
            rootDOM: node,
            platform: 10 /* enum PlatformType {AppCenter = 10} */,
          });
        });
      }}
    />
  );
}
